export const ColumnWidthsShares = [40, 315, 305, 260, 110, 60];
export const ColumnWidths = [40, 328, 309, 301, 100];
export const ColumnTotalWidths = ColumnWidths.reduce((a, b) => a + b, 0);
